import { Moment } from 'moment';
import React from 'react';
import { PaymentState } from '../../../Enums/paymentState.enum';
// @ts-ignore
import styles from './InvoicingTableItem.module.scss';
import LinkButton from '../../../../../Components/Button/LinkButton';
import { Theme } from '../../../../../Enums/Theme.enum';
import { joinClasses } from '../../../../../Utils/className.util';
import useTranslation from '../../../../../Hooks/useTranslation';
import FormattedMomentDate, {
	DateFormat,
} from '../../../../Base/Components/FormattedMomentDate/FormattedMomentDate';

export interface InvoicedOrder {
	id: string;
	attachmentNumber?: string;
	invoices: {
		id: string;
		url: string;
		number: string;
	}[];
	createDate: Moment;
	state: PaymentState;
	invoiceCreatedBy: string;
	customer: string;
	description: string;
	amount: string;
	commission: string;
}

interface Props {
	item: InvoicedOrder;
}
const InvoicingTableItem: React.FC<Props> = ({ item }) => {
	const { t } = useTranslation();

	return (
		<tr className={styles.wrapper}>
			<td>
				<div className={styles.invoices}>
					{item.state === PaymentState.PAID &&
						item.invoices?.map(
							(invoice: { id: string; url: string; number: string }) => (
								<React.Fragment key={invoice?.url}>
									<LinkButton
										title={invoice.number}
										theme={Theme.BLUE}
										href={invoice.url}
										className={styles.link}
									/>
								</React.Fragment>
							),
						)}
				</div>
			</td>
			<td>
				<FormattedMomentDate date={item.createDate} format={DateFormat.DATE} />
			</td>
			<td className={joinClasses([styles[item.state], styles.state])}>
				{item.state === PaymentState.PAID
					? t('component.invoicing.paid')
					: t('component.invoicing.unpaid')}
			</td>
			<td>{item.customer}</td>
			<td>{item.invoiceCreatedBy}</td>
			<td>{item.description}</td>
			<td>{item.amount}</td>
			<td className={styles.commission}>{item.commission}</td>
		</tr>
	);
};

export default InvoicingTableItem;
